import { createAsyncThunk } from '@reduxjs/toolkit'
import PlaywatchSettings from './playwatch-settings-model'
import {
  delete_playwatchSettings,
  load_playwatchSettingss,
  store_playwatchSettings,
} from './playwatchSettings-service'

export const LoadPlaywatchSettingssAsync = createAsyncThunk<any, any>(
  'composer/load/playwatchSettings',
  async (params: { uid: string }) => {
    return await load_playwatchSettingss(params)
  },
)

export const CreatePlaywatchSettingsAsync = createAsyncThunk<any, any>(
  'composer/create/playwatchSettings',
  async (params: PlaywatchSettings) => {
    return await store_playwatchSettings(params)
  },
)

export const DeletePlaywatchSettingsAsync = createAsyncThunk<any, any>(
  'composer/delete/playwatchSettings',
  async (params) => {
    return await delete_playwatchSettings(params)
  },
)
